import React, { useEffect, Suspense, lazy } from 'react';
import { initMetaPixel, trackPageView, trackViewContent } from './utils/metaPixel';
import { CountdownBanner } from './components/CountdownBanner';
import { HeroSection } from './components/HeroSection';
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const FeaturesSection = lazy(() => import('./components/FeaturesSection').then(m => ({
  default: m.FeaturesSection
})));
const HowItWorks = lazy(() => import('./components/HowItWorks').then(m => ({
  default: m.HowItWorks
})));
const ProofSection = lazy(() => import('./components/ProofSection').then(m => ({
  default: m.ProofSection
})));
const ReviewsSection = lazy(() => import('./components/ReviewsSection').then(m => ({
  default: m.ReviewsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const ClosingSection = lazy(() => import('./components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PopupNotifications = lazy(() => import('./components/PopupNotifications').then(m => ({
  default: m.PopupNotifications
})));
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackViewContent();
  }, []);
  return <div className="min-h-screen bg-[#0A0A0A] text-[#E8E0D0] font-sans selection:bg-[#D4AF37]/30 selection:text-white" data-id="element-0">
      <CountdownBanner data-id="element-1" />
      <HeroSection data-id="element-2" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-4" />} data-id="element-3">
        <ProofSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <MethodSection data-id="element-7" />
        <FeaturesSection data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <ReviewsSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <ClosingSection data-id="element-12" />
        <Footer data-id="element-13" />
        <PopupNotifications data-id="element-14" />
      </Suspense>
    </div>;
}